<template>
  <!-- note: infinite-scroll-disabled is just a string matching the property name and not the actual value -->
  <component :is="tagType" v-infinite-scroll="callback" :infinite-scroll-distance="scrollDistance" infinite-scroll-disabled="disable">
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: ['callback', 'tag', 'distance', 'disable'],
  computed: {
    scrollDistance: function () {
      return this.distance || 25
    },
    tagType: function () {
      return this.tag ? this.tag : 'div'
    }
  }
}
</script>
